import React from "react";
import CommonDataTable from "../../../components/Datatable/CommonDataTable";
import CommonDropdown from "../../../components/dropdown/CommonDropdown";
import DropdownButton from "../../../components/dropdown/DropdownButton";
import { formataData } from "../../../helpers/mesesHelper";
import Badge from "../../../components/Common/Badge/Badge";
import { AppContext } from "../../../contexts/AppContext";
import PropTypes from "prop-types";

function DemissoesDataTable({
  colaboradores,
  togVisualizarDemissaoModal,
  solicitarCancelamentoDemissao,
  togAprovarDemissaoModal,
  cancelarDemissao,
}) {
  const { session, baseUrl } = React.useContext(AppContext);

  const colunas = React.useMemo(
    () => [
      {
        Header: "Nome",
        accessor: "nome",
      },
      {
        Header: "CPF",
        accessor: "cpf",
        disableSortBy: true,
      },
      {
        Header: "Data de admissão",
        accessor: (row) => {
          return formataData(row.data_admissao);
        },
        disableSortBy: true,
      },
      {
        Header: "Data de demissao",
        accessor: (row) => {
          return formataData(row.data_demissao);
        },
        disableSortBy: true,
      },
      {
        Header: "Status",
        disableSortBy: true,
        Cell: ({ row }) => {
          let status = "";

          switch (parseInt(row.original.status)) {
            case 1:
              status = <Badge color="warning">Aguardando demissão</Badge>;
              break;

            case 2:
              status = <Badge color="danger">Aguardando cancelamento</Badge>;
              break;

            case 3:
              status = <Badge color="success">Demitido</Badge>;
              break;

            default:
              break;
          }
          return status;
        },
      },
      {
        Header: "Ações",
        disableSortBy: true,
        Cell: ({ row }) => {
          var status = [];
          status.push(
            <>
              <DropdownButton
                key={`dados-colaborador-${row.original.uid}`}
                onClick={() => {
                  window.location.href = `${baseUrl}colaboradores/Colaborador/ativo/${row.original.uid}`;
                }}
                color="success"
                icon="mdi mdi-card-account-details"
              >
                Dados do colaborador
              </DropdownButton>
              <DropdownButton
                key={`visualizar-${row.original.uid}`}
                onClick={() => {
                  togVisualizarDemissaoModal(row.original.uid);
                }}
                color="primary"
                icon="mdi mdi-account-search"
              >
                Visualizar
              </DropdownButton>
            </>
          );

          if (parseInt(row.original.status) === 1)
            status.push(
              <DropdownButton
                key={`solicitar-cancelamento-${row.original.uid}`}
                onClick={() => {
                  solicitarCancelamentoDemissao(row.original.uid);
                }}
                color="danger"
                icon="mdi mdi-account-cancel"
              >
                Solicitar cancelamento
              </DropdownButton>
            );

          if (
            [1, 2].includes(parseInt(row.original.status)) &&
            parseInt(session.codigo) === 99
          )
            status.push(
              <DropdownButton
                key={`aprovar-demissao-${row.original.uid}`}
                onClick={() => {
                  togAprovarDemissaoModal(
                    row.original.uid,
                    parseInt(row.original.tipo_demissao),
                    parseInt(row.original.categoria),
                  );
                }}
                color="success"
                icon="mdi mdi-account-remove"
              >
                Aprovar demissão
              </DropdownButton>
            );
          if (
            parseInt(row.original.status) === 2 &&
            parseInt(session.codigo) === 99
          )
            status.push(
              <DropdownButton
                key={`confirmar-cancelamento-${row.original.uid}`}
                onClick={() => {
                  cancelarDemissao(row.original.uid);
                }}
                color="danger"
                icon="mdi mdi-account-cancel"
              >
                Confirmar cancelamento
              </DropdownButton>
            );

          return <CommonDropdown>{status}</CommonDropdown>;
        },
      },
    ],
    [
      baseUrl,
      cancelarDemissao,
      session.codigo,
      solicitarCancelamentoDemissao,
      togAprovarDemissaoModal,
      togVisualizarDemissaoModal,
    ]
  );

  return <CommonDataTable colunas={colunas} linhas={colaboradores} />;
}

DemissoesDataTable.propTypes = {
  colaboradores: PropTypes.arrayOf(PropTypes.object).isRequired,
  togVisualizarDemissaoModal: PropTypes.func.isRequired,
  solicitarCancelamentoDemissao: PropTypes.func.isRequired,
  togAprovarDemissaoModal: PropTypes.func.isRequired,
  cancelarDemissao: PropTypes.func.isRequired,
  row: PropTypes.object,
};

export default DemissoesDataTable;
